module.exports = __webpack_public_path__ + "static/media/Union-white.8e0e86c1.svg";